import { render, staticRenderFns } from "./ShelfShowMore.vue?vue&type=template&id=53e19324&scoped=true&"
import script from "./ShelfShowMore.vue?vue&type=script&lang=js&"
export * from "./ShelfShowMore.vue?vue&type=script&lang=js&"
import style0 from "./ShelfShowMore.vue?vue&type=style&index=0&id=53e19324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e19324",
  null
  
)

export default component.exports